import { Icon } from '@chakra-ui/react';
import { BsArrowDownShort } from 'react-icons/bs';

const ArrowDownIcon = (props) => {
  return (
    <Icon as={BsArrowDownShort} {...props} />
  );
}

export default ArrowDownIcon;